/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A hash is a fixed-length fingerprint of your input. The same text always produces the same hash, but you can't reverse a hash back to the original text.`)
};

const es_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hash es una huella digital de longitud fija de tu entrada. El mismo texto siempre produce el mismo hash, pero no puedes revertir un hash de vuelta al texto original.`)
};

const de_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Hash ist ein Fingerabdruck mit fester Länge Ihrer Eingabe. Der gleiche Text erzeugt immer den gleichen Hash, aber Sie können einen Hash nicht rückgängig machen, um zum ursprünglichen Text zurückzukehren.`)
};

const nl_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een hash is een vingerafdruk met vaste lengte van uw invoer. Dezelfde tekst produceert altijd dezelfde hash, maar u kunt een hash niet terugdraaien naar de originele tekst.`)
};

const fr_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hash est une empreinte de longueur fixe de votre entrée. Le même texte produit toujours le même hash, mais vous ne pouvez pas inverser un hash pour retrouver le texte d'origine.`)
};

const it_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hash è un'impronta digitale di lunghezza fissa del tuo input. Lo stesso testo produce sempre lo stesso hash, ma non puoi invertire un hash per tornare al testo originale.`)
};

const pt_br2_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um hash é uma impressão digital de comprimento fixo da sua entrada. O mesmo texto sempre produz o mesmo hash, mas você não pode reverter um hash de volta ao texto original.`)
};

const pt_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um hash é uma impressão digital de comprimento fixo da sua entrada. O mesmo texto sempre produz o mesmo hash, mas não pode reverter um hash de volta ao texto original.`)
};

const ja_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハッシュは入力の固定長フィンガープリントです。同じテキストは常に同じハッシュを生成しますが、ハッシュから元のテキストに戻すことはできません。`)
};

const zh_hg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哈希是你输入内容的固定长度指纹。相同的文本总会产生相同的哈希值，但无法将哈希值还原回原始文本。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq1_a", locale)
	if (locale === "en") return en_hg_faq1_a(inputs)
	if (locale === "es") return es_hg_faq1_a(inputs)
	if (locale === "de") return de_hg_faq1_a(inputs)
	if (locale === "nl") return nl_hg_faq1_a(inputs)
	if (locale === "fr") return fr_hg_faq1_a(inputs)
	if (locale === "it") return it_hg_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq1_a(inputs)
	if (locale === "pt") return pt_hg_faq1_a(inputs)
	if (locale === "ja") return ja_hg_faq1_a(inputs)
	return zh_hg_faq1_a(inputs)
};